import type { UploadResult } from './useUpload';

// Show the most actionable rows first: failures, then warnings (skips/renames),
// then clean successes. A lone failed file otherwise gets buried in the middle of a
// huge upload (see the bug report). Same priority drives the summary badge order.
const RESULT_SORT_RANK: Record<UploadResult['status'], number> = {
  failed: 0,
  skipped: 1,
  folder_skipped: 1,
  renamed: 1,
  uploaded: 2,
  folder_created: 2,
};

/**
 * Returns a new array ordered failures → warnings → successes. The sort is stable
 * (Array.prototype.sort, ES2019+), so files keep their original order within a group.
 */
export function sortUploadResults(results: UploadResult[]): UploadResult[] {
  return [...results].sort((a, b) => RESULT_SORT_RANK[a.status] - RESULT_SORT_RANK[b.status]);
}
